import BaseBusinessAPI from '../portal/baseBusinessAPI'
class EnrollmentStudentAttachmentAPI extends BaseBusinessAPI {
  controllerName = 'EnrollmentStudentAttachments';
}

export default new EnrollmentStudentAttachmentAPI()
